
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      displayFixtures: [],
      filtersActive: false,
      sort: {
        asc: false,
        desc: false,
      },
      calendarPeriods: [],
      calendarPeriod: {},
      filterChoices: [],
      selectedFilters: {
        state: `All`,
        side: `All`,
        team: `All`,
        competition: `All`,
      },
      selectedCalendarPeriod: {},
    };
  },
  computed: {
    stateFilter () {
      let fixtures = this.fixtures;

      if (this.selectedTeam) {
        fixtures = [
          ...this.checkIfExistsInFixture({
            fixtures,
            filterCallbackFn: fixture =>
              fixture?.fixture?.fixtureTeams?.find(
                team => team.team._name === this.selectedTeam,
              ),
          }),
        ];
      }

      return [
        ...this.getFixtureStatesFromFixtures({ fixtures: [...fixtures] }),
      ];
    },
    teamFilter () {
      let fixtures = this.fixtures;

      if (this.selectedState) {
        fixtures = [
          ...this.checkIfExistsInFixture({
            fixtures,
            filterCallbackFn: fixture =>
              fixture?.fixture?.state?.fixtureGrouping === this.selectedState,
          }),
        ];
      }

      return [
        ...new Set(
          this.getFixtureTeamsFromFixtures({ fixtures: [...fixtures] }),
        ),
      ]
        .filter(team => team !== `-`)
        .filter(team => team !== this.selectedTeamFromCms.displayName)
        .sort();
    },
    fixtureFilters () {
      const fixtureFilters = {
        state: [...this.stateFilter],
        side: [`Home`, `Away`, `Neutral`],
        team: [...this.teamFilter],
      };
      return fixtureFilters;
    },
    competitions () {
      let fixtures = this.allFixtures;

      if (this.selectedTeam) {
        fixtures = [
          ...this.checkIfExistsInFixture({
            fixtures,
            filterCallbackFn: fixture =>
              fixture?.fixture?.fixtureTeams?.find(
                team => team.team._name === this.selectedTeam,
              ),
          }),
        ];
      }

      if (this.selectedState) {
        fixtures = [
          ...this.checkIfExistsInFixture({
            fixtures,
            filterCallbackFn: fixture =>
              fixture?.fixture?.state?.fixtureGrouping === this.selectedState,
          }),
        ];
      }

      return this.getCompetitionNamesFromFixtures({ fixtures });
    },
    fixtures () {
      return this.selectedCompetitionFixtures || this.allFixtures;
    },
    selectedCompetitionFixtures () {
      return this.selectedCompetition
        ? [...this.allFixtures].filter(
          fixture => fixture.competition.name === this.selectedCompetition,
        )
        : null;
    },
    allFixtures () {
      return [
        ...this.getAllFixturesFromCalendarPeriod(this.calendarPeriod),
      ].sort();
    },
    selectedTeam () {
      const selectedTeam = this.selectedFilters.team;
      return selectedTeam && selectedTeam !== `All` ? selectedTeam : null;
    },
    selectedState () {
      const selectedState = this.selectedFilters.state;
      return selectedState && selectedState !== `All` ? selectedState : null;
    },
    selectedCompetition () {
      const selectedCompetition = this.selectedFilters.competition;
      return selectedCompetition && selectedCompetition !== `All`
        ? selectedCompetition
        : null;
    },
    allFixturesCalendarLink () {
      if (this.selectedCompetition) {
        const competitionId = this.objectDeepLookupByPathAdvanced({
          // TODO: prevent an extra recursive lookup by including the id in this.selectedFilters['competition']
          expectedValue: this.selectedCompetition,
        })(this.calendarPeriod, `seasons.competition.name`).id;
        return this.getCalendarLink({ entity: `season`, id: competitionId });
      }
      return this.getCalendarLink({
        entity: `calendarPeriod`,
        id: this.calendarPeriod?.id,
      });
    },
  },
  watch: {
    displayFixtures: {
      immediate: true,
      handler (displayFixtures) {
        const displayFixturesDeepCopy = displayFixtures.map(displayFixture =>
          this.objectDeepCopy(displayFixture),
        );
        this.$emit(`displayFixtures`, displayFixturesDeepCopy);
      },
    },
    calendarPeriod: {
      immediate: true,
      handler (calendarPeriod) {
        this.resetAndSortDisplayFixtures({
          allFixtures: this.allFixtures,
          displayFixtures: this.displayFixtures,
        });

        this.$emit(`calendarPeriod`, this.objectDeepCopy(calendarPeriod));
      },
    },
    filterChoices (filterChoices) {
      this.resetAndSortDisplayFixtures({
        allFixtures: this.allFixtures,
        displayFixtures: this.displayFixtures,
      });
      this.processFilters(filterChoices);
    },
  },
  async mounted () {
    this.$nextTick(() => {
      this.selectedCalendarPeriod.name = this.defaultCalendarPeriod.displayName;
      this.selectedCalendarPeriod.id = this.defaultCalendarPeriod.id;
      // this.calendarPeriod = this.selectedCalendarPeriod;
    });
    const calendarPeriods = await this.getCalendarPeriods();
    this.calendarPeriods = calendarPeriods
      ? calendarPeriods?.data
        ?.map(calendarPeriod => ({
          name: calendarPeriod.name,
          id: calendarPeriod.id,
        }))
        .sort((a, b) => b.name.localeCompare(a.name))
      : [];
    const calendarPeriod = this.defaultCalendarPeriod.id;
    this.calendarPeriod = await this.getCalendarPeriodAndAssociatedIncludes(
      calendarPeriod,
    );
    this.resetAndSortDisplayFixtures({
      allFixtures: this.allFixtures,
      displayFixtures: this.displayFixtures,
    });
  },
  methods: {
    // INTERFACES::
    resetAndSortDisplayFixtures ({ displayFixtures, allFixtures }) {
      this.displayFixtures = this.sortDisplayFixtures({
        displayFixtures: this.resetDisplayFixtures({
          allFixtures,
        }),
      });
    },
    checkFilterType (filter) {
      return filter === `All` ? `remove` : `add`;
    },
    handleFilterChoice (choice, action) {
      const existentFilter = this.filterChoices.findIndex(
        filterChoice => filterChoice[Object.keys(choice)[0]],
      );

      if (existentFilter > -1) {
        delete this.filterChoices[existentFilter];
        this.filterChoices = this.declutter(this.filterChoices);
      }
      if (action === `add`) return this.filterChoices.push(choice);
    },
    processFilters (filterChoices) {
      filterChoices.forEach(filter => {
        this.displayFixtures = this.filterDisplayFixtures({
          key: Object.keys(filter)[0],
          value: Object.values(filter)[0],
          displayFixtures: this.displayFixtures,
        });
      });
    },
    resetFilters (excludedKey, excludedValue) {
      this.filterChoices = [];
      const resetSelectedFilters = Object.keys(this.selectedFilters).reduce(
        (accumulator, key) =>
          key === excludedKey
            ? { ...accumulator, [key]: excludedValue }
            : { ...accumulator, [key]: `All` },
        {},
      );
      this.selectedFilters = resetSelectedFilters;
    },
    async resetCalendarPeriod (seasonId) {
      this.calendarPeriod = await this.getCalendarPeriodAndAssociatedIncludes(
        seasonId,
      );
    },
    displayFilters () {
      this.filtersActive = !this.filtersActive;
    },
    // ABSTRACTION BARRIER: // NOTE: methods below this point should be calculations as far as possible, and not actions
    async getCalendarPeriodAndAssociatedIncludes (id) {
      const paramArray = [
        `seasons.competition`,
        `seasons.stages.fixtures.firstLegFixture`,
        `seasons.stages.fixtures.venue`,
        `seasons.stages.fixtures.state`,
        `seasons.stages.fixtures.socialLinks.socialType`,
        `seasons.stages.fixtures.stage.season.competition`,
        `seasons.stages.fixtures.fixtureTeams.team.images`,
        `seasons.stages.fixtures.fixtureBroadcasts.broadcaster.images`,
        `seasons.stages.fixtures.fixtureBroadcasts.fixture`,
        `seasons.stages.fixtures.winType`,
        `seasons.squads`,
      ];
      const calendarPeriod = await this.getStats(
        `calendarPeriod${id ? `/${id}` : ``}`,
        { include: paramArray.join(`,`) },
      ).catch(_ => null);

      if (!calendarPeriod) return null;
      return calendarPeriod.data ?? {};
    },
    async getStats (path, params) {
      this.$parent.isLoading = true; // REVISIT: side-effect
      const response = await this.$getStats(path, params).catch(_ => null);
      if (!response) return null;
      this.$parent.isLoading = false;
      return response;
    },
    getCompetitionNamesFromFixtures ({ fixtures }) {
      const competitionNames = new Set();

      [...fixtures].forEach(fixture =>
        fixture.competition.name
          ? competitionNames.add(fixture.competition.name)
          : null,
      );

      return competitionNames;
    },
    getAllFixturesFromCalendarPeriod (calendarPeriod) {
      const fixtures = new Set();
      const calendarPeriodDeepCopy = this.objectDeepCopy(calendarPeriod);

      calendarPeriodDeepCopy?.seasons?.some(season =>
        season.stages.some(stage =>
          stage.fixtures.forEach(fixture => {
            if (
              !fixture?.fixtureTeams?.some(
                teamToFind =>
                  teamToFind.teamId === this.selectedTeamFromCms?.id,
              )
            ) {
              return;
            }

            const fixtureObject = {};
            fixtureObject.competition = season.competition;
            fixtureObject.stage = stage;
            fixtureObject.season = season;
            fixtureObject.fixture = fixture;
            fixtureObject.state = fixture.state; // NOTE: we need the state and team props to be first-level so that we can easily filter them without recursion (see filterDisplayFixtures())
            fixtureObject.team = fixture.fixtureTeams;
            fixtureObject.side = this.getSideFromFixture(
              fixture,
              this.selectedTeamFromCms?.id,
            );
            fixtureObject.opposition = this.getOppositionFromSelectedTeam(
              fixture,
              this.selectedTeamFromCms?.id,
            );
            delete fixtureObject.stage?.fixtures;
            delete fixtureObject.season?.stages;
            delete fixtureObject.competition?.seasons;
            delete fixtureObject.fixture.fixtureTeams?.team;
            return fixtures.add(fixtureObject);
          }),
        ),
      );
      return fixtures;
    },
    getFixtureStatesFromFixtures ({ fixtures }) {
      const states = new Set();

      fixtures.forEach(fixture =>
        fixture?.fixture?.state
          ? states.add(fixture.fixture.state.fixtureGrouping)
          : null,
      );

      return states;
    },
    getFixtureTeamsFromFixtures ({ fixtures }) {
      const teams = new Set();

      fixtures.forEach(fixture =>
        fixture?.fixture?.fixtureTeams
          ? fixture.fixture.fixtureTeams.forEach(team =>
            teams.add(team._name),
          )
          : null,
      );

      return teams;
    },
    checkIfExistsInFixture ({ fixtures, filterCallbackFn }) {
      return [...fixtures].filter(fixture => filterCallbackFn(fixture));
    },
    getFilterLabelByType (filter) {
      switch (filter) {
      case `state`:
        return `Fixtures/Results/Live`;
      case `team`:
        return `Opposition`;
      case `side`:
        return `Home/Away/Neutral`;
      default:
        return `Filter by ${filter}`;
      }
    },
    resetDisplayFixtures ({ allFixtures }) {
      return [...allFixtures]; // NOTE: since we're exclusively reading data that is trusted here, structural sharing is OK
    },
    sortDisplayFixtures ({ order = `asc`, displayFixtures }) {
      return [...displayFixtures]
        .sort((a, b) =>
          order === `asc`
            ? b.fixture.datetime.localeCompare(a.fixture.datetime)
            : a.fixture.datetime.localeCompare(b.fixture.datetime),
        )
        .reverse();
    },
    filterDisplayFixtures ({ key, value, displayFixtures }) {
      return [...displayFixtures].filter(fixture => {
        if (Array.isArray(fixture[key])) {
          // NOTE: handles edge-case of there being an array of objects (as for displayFixtures[0].team).
          // could handle this recursively, but there should only ever be one level of objects in the array

          return fixture[key].some(obj =>
            Object.values(obj).some(val => val === value),
          );
        }
        if (fixture[key] !== null) {
          return Object.values(fixture[key]).some(val => val === value);
        }
      });
    },
  },
};
